import React from 'react';
import PropTypes from 'prop-types';
import {translate} from '../../services';
import LinkWrapper from '../Reusable/LinkWrapper/LinkWrapper';
import './_error.scss';

const Error = ({errorType}) => (
  <section className='b-error'>
    <svg
      className='error-pic'
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      preserveAspectRatio='xMidYMid meet'
      role='img'
      aria-labelledby='error-title'>
      <title id='error-title'>{errorType}</title>
      <defs>
        <mask id='masked-text' x='0' y='0' width='100%' height='100%'>
          <rect x='0' y='0' width='100%' height='100%' fill='white'/>
          <text className='text' x='50%' y='185' textAnchor='middle' fontFamily='Lato, Arial'>{errorType}</text>
        </mask>
      </defs>
      <rect x='0' y='0' width='100%' height='100%' fill='#267D8C'/>
      <rect x='0' y='0' width='100%' height='100%' mask='url(#masked-text)' fill='white'/>
    </svg>

    <p className='error-description'>{translate(`errors.errorPages.${errorType}`)}</p>

    {(errorType === 404 || errorType === 403) ?
      <LinkWrapper
        className='button-link'
        hrefValue='/'
        contents={translate('errors.errorPages.goHome')} /> :
      <LinkWrapper
        className='button-link'
        hrefValue='https://www.etsy.com/market/spoonflower'
        contents={translate('errors.errorPages.shopElsewhere')} />}

    {/*  credit to designer when we have a 404 page with artwork
      <p className='artwork'>
        {translate('errors.errorPages.artwork')}
        <LinkWrapper
          className='link'
          contents={USED_DESIGNER_NAME}
          hrefValue={`${MultiLocaleRouter.localePathname(ROUTING_PATH_FABRIC)}/4501416`}/>
      </p>
      */}
  </section>
);

Error.defaultProps = {
  errorType: 404
};

Error.propTypes = {
  errorType: PropTypes.number
};

export default Error;
